import { render, staticRenderFns } from "./mainContentDiv.vue?vue&type=template&id=1c9232e0&scoped=true&"
import script from "./mainContentDiv.vue?vue&type=script&lang=js&"
export * from "./mainContentDiv.vue?vue&type=script&lang=js&"
import style0 from "./mainContentDiv.vue?vue&type=style&index=0&id=1c9232e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9232e0",
  null
  
)

export default component.exports